module.exports = __webpack_public_path__ + "static/media/9DESA25.3bb98bc9.jpg";